import { MasterCrudPage } from '@/components/MasterCrudPage.jsx';
import { formatDate } from '@/lib/format.js';

export default function HolidaysPage() {
  return (
    <MasterCrudPage
      title="Holidays"
      description="Public/company holidays calendar"
      endpoint="/holidays"
      queryKey={['holidays']}
      fields={[
        { name: 'date', label: 'Date', type: 'date', required: true },
        { name: 'name', label: 'Name', required: true },
        { name: 'type', label: 'Type', type: 'select', default: 'public', options: [
          { value: 'public', label: 'Public' },
          { value: 'mercantile', label: 'Mercantile' },
          { value: 'company', label: 'Company' },
        ]},
      ]}
      columns={[
        { key: 'date', header: 'Date', sortable: true, render: (r) => formatDate(r.date) },
        { key: 'name', header: 'Name', sortable: true },
        { key: 'type', header: 'Type' },
      ]}
    />
  );
}
